import { render, staticRenderFns } from "./FleetVehiclesDetails.vue?vue&type=template&id=2e8824aa"
import script from "./FleetVehiclesDetails.vue?vue&type=script&lang=js"
export * from "./FleetVehiclesDetails.vue?vue&type=script&lang=js"
import style0 from "./FleetVehiclesDetails.vue?vue&type=style&index=0&id=2e8824aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports